export default __webpack_public_path__ + "static/media/iphone.471f6092.png";